import { inject, Injectable } from '@angular/core';
import { SnackbarService } from '../snack-bar-service/snackbar.service';

@Injectable({ providedIn: 'root' })

export class GlobalErrorHandlerService {
  private snackbar = inject(SnackbarService);

  handleError(error: any): void {
    const status = error?.status;
    let message = 'An unexpected error occurred.';
    if (status) {
      switch (status) {
        case 302:
          message = 'Unauthorized. Please login again.';
          break;
        case 404:
          message = 'The requested resource was not found.';
          break;
        case 401:
          message = 'Unauthorized. Please login again.';
          break;
        case 403:
          message = 'Access denied.';
          break;
        case 440:
          message = 'Unauthorized. Please login again.';
          break;
        case 500:
          if (error?.error?.errors?.[0]?.detailedMessage) {
            message = error?.error?.errors?.[0]?.detailedMessage;
          } else {
            message = error?.error?.errors?.[0]?.message || `Error ${status}: ${error.statusText}`;
          }
          break;
        default:
          /** Try to extract error message from backend if available other than 500 */
          message = error?.error?.errors?.[0]?.message || `Error ${status}: ${'Unauthorized. Please login again.'}`;
          break;
      }
    }
    this.snackbar.show(message, 5000, 'bottom');
  }
}
